import {
  MDBBreadcrumb,
  MDBBreadcrumbItem,
  MDBBtn,
  MDBChip,
  MDBCol,
  MDBTabs,
  MDBTabsItem,
  MDBTabsLink,
  MDBTabsContent,
  MDBTabsPane,
  MDBRow,
  MDBScrollspy,
  MDBScrollspyLink,
  MDBSpinner,
} from "mdb-react-ui-kit";
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import Body from "../components/body/BodyPage";
import MainLinks from "../components/navlinks/MainLinks";
import { useLocation, useNavigate } from "react-router";
import FaxGroupGeneralSettings from "./FaxGroupGeneralSettings";
import FaxGroupAttribute from "./FaxGroupAttribute";
import FaxGroupUsers from "./FaxGroupUsers";
import {
  getSpecificFaxGroupsDetails,
  updateFaxGroup,
} from "../apiclients/streamsapi_bridge";
import { useForm } from "react-hook-form";
import TopSuccess from "../components/header/TopSuccess";
import TopMessage from "../components/header/TopMessage";
import SaveChanges from "../components/topviews/saveCancel";
import { useAdminContext } from "../components/adminstore/Admin-Context";
import EditWarning from "../components/header/EditWarning";
function FaxGroupsDetails() {
  const [selectedRegion, setSelectedRegion] = useState("IN");
  const { t, i18n } = useTranslation();
  const location = useLocation();
  const [faxGroupInfo, setfaxGroupInfo] = useState(
    location.state ? location.state : {}
  );

  const containerRef = useRef(null);
  const section1 = useRef(null);
  const section2 = useRef(null);
  const [rerender, setRerender] = useState(false);
  const [isloading, setIsloading] = useState(false);
  const [users, setusers] = useState([]);
  const [dids, setdids] = useState([]);
  const [successMessage, setSuccessMessage] = useState("");
  const { isEdited, setEdited } = useAdminContext();
  const [targetView, setTargetView] = useState("");
  const [showWarning, setShowWarning] = useState(false);
  const warningToggle = () => setShowWarning(!showWarning);
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors, isDirty, dirtyFields },
    setValue,
    watch,
    setError,
    clearErrors,
    getValues,
  } = useForm({
    defaultValues: {
      name: "",
      // mailid: "",
      // retries: 1,
      loc_id: 0,
      billing_grp: 0,
      // attributes: {
      primary_did: "",
      // },
      // removedids: [],
      // adddids: [],
      // removedUsers: [],
      // addedUsers: [],
    },
  });

  useEffect(() => {
    if (successMessage) {
      setTimeout(() => {
        setSuccessMessage(""); // Clear the success message in the parent component
      }, 5000);
    }
  }, [successMessage]);

  async function getSpecificFaxGroups() {
    try {
      setIsloading(true);
      const response = await getSpecificFaxGroupsDetails(
        JSON.parse(sessionStorage.getItem("admin_session")).siteid,
        faxGroupInfo.code
      );
      setTimeout(() => {
        setIsloading(false);
      }, 1000);
      const faxgroupdetails = await response.json();
      console.log(
        "getSpecific getSpecificFaxGroupsDetails ::: " +
          JSON.stringify(faxgroupdetails)
      );
      setusers(faxgroupdetails?.users ?? []);
      setdids(faxgroupdetails?.attributes?.did ?? []);
      reset({
        name: faxgroupdetails?.name ?? "",
        // mailid: faxgroupdetails?.mailid ?? "",
        // retries: faxgroupdetails?.retries ?? 1,
        loc_id: faxgroupdetails?.loc_id ? parseInt(faxgroupdetails?.loc_id) : 0,
        billing_grp: faxgroupdetails?.billing_grp
          ? parseInt(faxgroupdetails?.billing_grp)
          : 0,
        // attributes: {
        primary_did: faxgroupdetails?.attributes?.primaryfaxdid ?? "",
        // },
      });

      setRerender(false);
    } catch (error) {}
  }

  useEffect(() => {
    if (faxGroupInfo.code || rerender) {
      getSpecificFaxGroups();
      setRerender(false);
    }
  }, [faxGroupInfo.code, rerender]);

  const [basicActive, setBasicActive] = useState("tab1");

  const handleBasicClick = (value) => {
    if (value === basicActive) {
      return;
    } else if (isEdited) {
      setTargetView(value);
      setShowWarning(true);
      return;
    }

    setBasicActive(value);
  };

  const handleOk = () => {
    setEdited(false);
    reset();
    if (targetView.indexOf("/") !== -1) {
      navigate(targetView);
    } else {
      setBasicActive(targetView);
    }
    setShowWarning(false);
  };

  const isSave = Object.keys(dirtyFields).length === 0 ? false : true;

  useEffect(() => {
    setEdited(isSave);
  }, [isSave]);

  const onSubmit = async (data) => {
    let modifiedData = extractModifiedFields(dirtyFields, data);
    if (modifiedData) {
      modifiedData.reqid = 117;
      modifiedData.siteid = JSON.parse(
        sessionStorage.getItem("admin_session")
      ).siteid;
      modifiedData.code = parseInt(faxGroupInfo.code);

      console.log(
        "modified data for company info :::" + JSON.stringify(modifiedData)
      );
      setIsloading(true);
      let saverep = await updateFaxGroup(modifiedData);
      console.log(`reponse of Edit fax Group :::: ${JSON.stringify(saverep)}`);
      let saverepeMsg = await saverep.json();
      console.log(
        "response of modified data fax Group  :::" + JSON.stringify(saverepeMsg)
      );
      setTimeout(() => {
        setIsloading(false);
      }, 1000);
      if (saverepeMsg.status && saverepeMsg.status == "success") {
        setRerender(true);
        setSuccessMessage(saverepeMsg.message);
      } else {
        if (saverepeMsg.message?.errors) {
          saverepeMsg.message.errors.forEach((err) => {
            setError(err.param_name, {
              type: "server",
              message: err.message,
            });
            const fieldElement = document.querySelector(
              `input[name="${err.param_name}"]`
            );
            if (fieldElement) {
              fieldElement.focus();
              fieldElement.scrollIntoView({ behavior: "smooth" });
            }
          });
        }
      }
    }
  };

  function extractModifiedFields(dirtyFields, data) {
    const modifiedData = {};

    function recurse(dirtyFields, data, modifiedData) {
      for (const field of Object.keys(dirtyFields)) {
        if (dirtyFields[field] && data.hasOwnProperty(field)) {
          if (typeof data[field] === "object" && !Array.isArray(data[field])) {
            modifiedData[field] = {};
            recurse(dirtyFields[field], data[field], modifiedData[field]);
          } else {
            modifiedData[field] = data[field];
          }
        }
      }
    }

    recurse(dirtyFields, data, modifiedData);
    return modifiedData;
  }

  function closeSave(e) {
    reset();
  }

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      const scrollspyLinks = document.querySelectorAll(".nav-link");
      const lastLink = scrollspyLinks[scrollspyLinks.length - 1];
      const stickyParent = lastLink.closest(".sticky-top");
      if (stickyParent && lastLink.classList.contains("active")) {
        lastLink.classList.remove("active");
        for (let i = 0; i < scrollspyLinks.length; i++) {
          const firstLink = scrollspyLinks[i];
          const parent = firstLink.closest(".sticky-top");
          if (parent) {
            firstLink.classList.add("active");
            break;
          }
        }
      }
    }, 100);
    return () => clearTimeout(timeoutId);
  }, []);

  return (
    <React.Fragment>
      <>
        <MainLinks active={2} />
        <Body
          tablinks={2}
          sublink={281}
          content={
            <>
              <section className="mb-3">
                <div className="card card-height">
                  <div className="card-header py-3 px-0">
                    <h5 className="mb-0 ">
                      <MDBBreadcrumb>
                        <MDBBreadcrumbItem>
                          <a
                            onClick={(e) => {
                              if (isEdited) {
                                setTargetView("/huntgroup");
                                setShowWarning(true);
                                return;
                              }
                              navigate("/huntgroup");
                            }}
                          >
                            <strong>Phone System</strong>
                          </a>
                        </MDBBreadcrumbItem>
                        <MDBBreadcrumbItem active>
                          <a
                            onClick={(e) => {
                              if (isEdited) {
                                setTargetView("/faxgroupslandingpage");
                                setShowWarning(true);
                                return;
                              }
                              navigate("/faxgroupslandingpage");
                            }}
                          >
                            <strong>Fax Groups</strong>
                          </a>
                        </MDBBreadcrumbItem>
                        <MDBBreadcrumbItem>
                          <a href="">
                            <strong>{watch("name")}</strong>
                          </a>
                        </MDBBreadcrumbItem>
                      </MDBBreadcrumb>
                    </h5>
                  </div>
                  <div className="card-body px-0">
                    <div className="pb-2">
                      <h5 className="fw-600 mt-2 ">{watch("name")}</h5>
                      {/* <p className="mt-2 text-secondary">Group Type : Fax</p> */}
                      {/* <p className="mt-2 text-secondary">
                        Group Mail ID: {watch("mailid")}
                      </p> */}
                    </div>

                    <MDBTabs className="mb-3">
                      <MDBTabsItem>
                        <MDBTabsLink
                          onClick={() => handleBasicClick("tab1")}
                          active={basicActive === "tab1"}
                        >
                          Settings
                        </MDBTabsLink>
                      </MDBTabsItem>
                      <MDBTabsItem>
                        <MDBTabsLink
                          onClick={() => handleBasicClick("tab2")}
                          active={basicActive === "tab2"}
                        >
                          Users
                        </MDBTabsLink>
                      </MDBTabsItem>
                    </MDBTabs>

                    <MDBTabsContent>
                      <MDBTabsPane open={basicActive === "tab1"}>
                        <MDBRow>
                          <MDBCol md="2">
                            <MDBScrollspy container={containerRef}>
                              <MDBScrollspyLink targetRef={section1}>
                                General
                              </MDBScrollspyLink>
                              <MDBScrollspyLink targetRef={section2}>
                                Phone Numbers
                              </MDBScrollspyLink>
                            </MDBScrollspy>
                          </MDBCol>

                          <MDBCol md="8">
                            <div
                              id="element"
                              ref={containerRef}
                              className="scrollspy-example"
                            >
                              <section ref={section1} id="section-1">
                                <FaxGroupGeneralSettings
                                  register={register}
                                  errors={errors}
                                  watch={watch}
                                  setValue={setValue}
                                />
                              </section>
                              <div className="routing-border mt-2"></div>
                              <section ref={section2} id="section-2">
                                <FaxGroupAttribute
                                  register={register}
                                  errors={errors}
                                  watch={watch}
                                  dids={dids}
                                  setError={setError}
                                  setSuccessMessage={setSuccessMessage}
                                  code={faxGroupInfo.code}
                                  setValue={setValue}
                                  reset={reset}
                                  getValues={getValues}
                                  setIsloading={setIsloading}
                                  clearErrors={clearErrors}
                                />
                              </section>
                            </div>
                          </MDBCol>
                        </MDBRow>
                      </MDBTabsPane>
                      <MDBTabsPane open={basicActive === "tab2"}>
                        <div>
                          <FaxGroupUsers
                            users={users}
                            code={faxGroupInfo.code}
                            isActive={basicActive === 'tab2'}
                          />
                        </div>
                      </MDBTabsPane>
                    </MDBTabsContent>
                    {isSave && (
                      <SaveChanges
                        onClose={closeSave}
                        isdirtyFields={isSave}
                        onSave={(e) => {
                          e.preventDefault();
                          handleSubmit(onSubmit)();
                        }}
                      />
                    )}
                  </div>
                </div>
              </section>
            </>
          }
        />
        {isloading && (
          <>
            <div className="loadingclass">
              <MDBBtn disabled>
                <MDBSpinner
                  size="sm"
                  role="status"
                  tag="span"
                  className="me-2"
                />
                Loading...
              </MDBBtn>
            </div>
          </>
        )}

        {successMessage && (
          <>
            <TopSuccess>
              <TopMessage successMessage={successMessage} />
            </TopSuccess>
          </>
        )}

        {showWarning && (
          <EditWarning
            warningToggle={warningToggle}
            setShowWarning={setShowWarning}
            onOk={handleOk}
          />
        )}
      </>
    </React.Fragment>
  );
}

export default FaxGroupsDetails;
